var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 245,
    height: 244,
    viewBox: "0 0 245 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M244.729 119.679C178.601 119.679 125.051 66.0743 125.051 0H120.408V119.679H0.729492V124.321C66.8578 124.321 120.408 177.926 120.408 244H125.051V124.321H244.729V119.679Z",
    fill: "#F50DB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUlogo);
export default __webpack_public_path__ + "static/media/ulogo.508b48b8cfe547c6d9c5921fabeac704.svg";
export { ForwardRef as ReactComponent };